export const VIEW_ID_NEW = "new";
export const VIEW_MODE_EDIT = "edit";
